import React from 'react';

export default ({ changeHandler, isToggleOn }) => {
  return (
    <label className="billy-switch" aria-label="מתג" tabIndex="0">
      <input type="checkbox"  checked={ isToggleOn } onChange={ changeHandler } />
      <div className="billy-switch__slider" aria-hidden="true"></div>
    </label>
  )
}


// WEBPACK FOOTER //
// ./src/components/Switcher/index.js